/**
 * @file   src\mobile\components\PauseWantAdModal.js
 * @brief  This file is responsible for showing pause wantad modal
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { Modal } from "react-bootstrap";

const PauseWantAdModal = (props) => {
  const { show, onHide, handleConfirm } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
      {...props}
      centered
      className="modalPopupstyle delete-popup"
    >
      <Modal.Body className="text-center">
        <h3>Are you sure you want to pause your want-listing?</h3>
        <p>
          Pausing this listing will stop any further introductions from being sent to
          you, and it will be removed from the listing feed.
        </p>
        <p>
          You can unpause your want-listing when you’re ready to receive
          introductions.
        </p>
        <div className="btn-wrap">
          <button
            type="button"
            className="btn btn-primary w-100"
            onClick={handleConfirm}
          >
            Confirm
          </button>
          <button
            type="button"
            className="btn btn-secondary w-100"
            onClick={onHide}
          >
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default PauseWantAdModal;
